import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import NewsCard from "../../components/football/NewsCard";
import api from "../../lib/api";

const CATS = ["All", "NFL", "College"];

export default function FootballNews() {
    const [params, setParams] = useSearchParams();
    const catParam = params.get("category") || "All";
    const [cat, setCat] = useState(catParam);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const q = {};
        if (cat !== "All") q.category = cat;
        q.limit = 60;
        api.get("/football/news", { params: q })
            .then(r => setItems(r.data))
            .finally(() => setLoading(false));
        setParams(cat === "All" ? {} : { category: cat });
    }, [cat, setParams]);

    return (
        <PageLayout>
            <section className="pt-28 pb-10 border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Football News</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="news-heading">
                        THE <span className="text-[#d4af37]">HEADLINES.</span>
                    </h1>
                    <div className="mt-6 flex gap-2 flex-wrap">
                        {CATS.map(c => (
                            <button key={c} onClick={() => setCat(c)} className={`chip ${cat === c ? "chip-active" : ""}`} data-testid={`news-filter-${c.toLowerCase()}`}>{c}</button>
                        ))}
                    </div>
                </div>
            </section>
            <TrendingBar />

            <section className="py-10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    {loading ? (
                        <div className="text-white/40 text-center py-20">Loading headlines…</div>
                    ) : items.length === 0 ? (
                        <div className="text-white/40 text-center py-20">No headlines yet. Refresh in a few minutes.</div>
                    ) : (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="news-grid">
                            {items.map(n => <NewsCard key={n.id} item={n} testid={`news-item-${n.id}`} />)}
                        </div>
                    )}
                </div>
            </section>
        </PageLayout>
    );
}
